import { useState, useContext, useEffect } from "react";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import RachatTrimestrePage from "./rachatTrimestre";
import RetraiteProgressivePage from "./retraiteProgressive";
import CumulEmploiRetraitePage from "./cumulEmploiReraite";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { CalculPrestationContrat } from "components/app/Api/Retraite/ApiRetraite";
import { FaCogs } from "react-icons/fa";
import "components/app/Extranet/ListeAudits.css";
// import AuditRetaiteLogo from "./images/Audit retraite.JPG";
// import AuditPrevoyanceLogo from "./images/Audit prevoyance.JPG";
// import AuditRemunerationLogo from "./images/Audit remuneration.JPG";

const SimulationRetraite = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [etude, setEtude] = useState("");
  useEffect(() => {
    const calculerRetraite = (clientConjoint) => {
      ResultatTNS.GetResultBilanRetraite(context.state, clientConjoint).then((ResultatRetraite) => {
        context.state["ListeContrat" + clientConjoint].forEach((contratRetraite) => {
          CalculPrestationContrat(context.state, clientConjoint, ResultatRetraite, contratRetraite.Salaire, contratRetraite).then(() => {});
        });
      });
    };

    if (props.openInModal) {
      calculerRetraite(props.ClientConjoint);
    } else {
      calculerRetraite("");
      if (context.state.InclureConjoint === true) {
        calculerRetraite("Conjoint");
      }
    }
    setEtude("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setEtude("");
  }, [props.ClientConjoint]);

  const renderEtude = () => {
    if (etude === "Rachat") {
      return <RachatTrimestrePage ClientConjoint={props.ClientConjoint} />;
    }
    if (etude === "RetraiteProgressive") {
      return <RetraiteProgressivePage ClientConjoint={props.ClientConjoint} />;
    }
    if (etude === "Cumul") {
      return <CumulEmploiRetraitePage ClientConjoint={props.ClientConjoint} accesSimulation={() => setEtude("")} />;
    }
    return null;
  };

  const getModalTitle = () => {
    if (etude === "Rachat") return "Rachat de trimestres";
    if (etude === "RetraiteProgressive") return "Retraite progressive";
    if (etude === "Cumul") return "Cumul emploi-retraite";
    return "Simulation retraite";
  };

  return (
    <>
      {(etude === "" || props.openInModal) && (
        <Column fill>
          <>
            <CardBox>
              <Column fill>
                <Row bpad>
                   <CardBoxHeader icon={<FaCogs />}>Simulations</CardBoxHeader>
                </Row>                <Row style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                  {/* Rachat de trimestres */}
                  <div 
                    className="audit-pack-card blue-theme" 
                    style={{ width: "200px", cursor: "pointer" }}
                    onClick={() => {
                      setEtude("Rachat");
                    }}
                  >                    <div className="audit-pack-card-icon">
                      ⏰
                    </div>
                    <h3 className="audit-pack-card-title">
                      Rachat de trimestres
                    </h3>
                    <p className="audit-pack-card-description">
                      Optimiser sa retraite
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Cumul emploi-retraite */}
                  {(ResultatTNS.state["Retraite" + props.ClientConjoint].InfosRetraiteChoixDepart?.TotalTrimestre >=
                    ResultatTNS.state["Retraite" + props.ClientConjoint].InfosRetraiteChoixDepart?.Infos?.DureeReference ||
                    ResultatTNS.state["Retraite" + props.ClientConjoint].InfosRetraiteChoixDepart?.Infos?.AgeDepartRetraite2 >=
                      ResultatTNS.state["Retraite" + props.ClientConjoint].InfosRetraiteChoixDepart?.Infos?.AgeTauxPlein) && (
                    <div 
                      className="audit-pack-card green-theme" 
                      style={{ width: "200px", cursor: "pointer" }}
                      onClick={() => {
                        setEtude("Cumul");
                      }}
                    >
                      <div className="audit-pack-card-icon">
                        ⚖️
                      </div>
                      <h3 className="audit-pack-card-title">
                        Cumul emploi-retraite
                      </h3>
                      <p className="audit-pack-card-description">
                        Travailler après la retraite
                      </p>
                      <div className="audit-pack-card-decoration"></div>
                    </div>
                  )}

                  {/* Retraite progressive */}
                  {context.state["DisplayRetraiteProgressive" + props.ClientConjoint] === true && (
                    <div 
                      className="audit-pack-card violet-theme" 
                      style={{ width: "200px", cursor: "pointer" }}
                      onClick={() => {
                        setEtude("RetraiteProgressive");
                      }}
                    >
                      <div className="audit-pack-card-icon">
                        📈
                      </div>
                      <h3 className="audit-pack-card-title">
                        Retraite progressive
                      </h3>
                      <p className="audit-pack-card-description">
                        Transition en douceur
                      </p>
                      <div className="audit-pack-card-decoration"></div>
                    </div>
                  )}
                </Row>
              </Column>
            </CardBox>
          </>
        </Column>
      )}
      {props.openInModal ? (
        etude !== "" && (
          <Modal
            width="90%"
            height="90%"
            title={getModalTitle()}
            icon={<FaCogs />}
            visible={etude !== ""}
            onClose={() => setEtude("")}
          >
            <Column scroll fill style={{ width: "100%" }}>
              {renderEtude()}
            </Column>
          </Modal>
        )
      ) : (
        renderEtude()
      )}
    </>
  );
};

export default SimulationRetraite;
